import { render, staticRenderFns } from "./Fortherecord.vue?vue&type=template&id=1f116f4f&scoped=true&"
import script from "./Fortherecord.vue?vue&type=script&lang=js&"
export * from "./Fortherecord.vue?vue&type=script&lang=js&"
import style0 from "./Fortherecord.vue?vue&type=style&index=0&id=1f116f4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f116f4f",
  null
  
)

export default component.exports